export const FieldType = Object.freeze({
  TEXT: "text",
  NUMBER: "number",
  IMAGE: "image",
  DATE: "date",
  COMPOSITE: "composite"
});

